import { type ReduxUser } from 'models';
import { canManageProgramRedux } from './canManageProgram';

export const canViewProgramMembersRedux = ({ viewer, program }: { viewer: ReduxUser; program: any }) =>
  program?.settings?.view_members || canManageProgramRedux({ viewer, program });
